<div class="body-wrapper my-5">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <alert></alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
<footer class="footer bg-dark-primary text-white">
    <div class="container d-none d-sm-block">
        <div class="py-1 pd-0 md-0 text-center">
            <nav class="navbar navbar-expand px-0">
                <ul class="nav navbar-nav mr-auto">
                    <li class="nav-item"><a href="#" class="nav-link text-white">Privacy Policy</a></li>
                    <li class="nav-item"><a href="#" class="nav-link text-white">Terms & Conditions</a></li>
                </ul>
                <ul class="nav navbar-nav">
                    <li class="nav-item">Copyright &copy; 2020 Flannel Jax's</li>
                </ul>
            </nav>
        </div>
    </div>
    <div class="container d-block d-sm-none">
        <p class="text-size-12 text-center pt-4">Copyright &copy; 2020 Flannel Jax's</p>
    </div>
</footer>